import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as solidIcons from '@fortawesome/free-solid-svg-icons';
import { useBusinessData } from '../../context/BusinessContext';
import '../../css/Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { loading, getData, getImageUrl } = useBusinessData();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Get business name from data
  const businessName = getData('name', 'BusinessInfo');
  
  // Get logo image if available
  const logoImage = getImageUrl('images.logo', null);
  
  // Check if donation is enabled
  const isDonationEnabled = getData('donation.enabled', false);

  // Determine what to display in the navbar
  const renderBrandContent = () => {
    // If both logo and name are available, show both
    if (logoImage && businessName) {
      return (
        <>
          <img src={logoImage} alt={businessName} className="logo-image" />
          <span className="business-name">{businessName}</span>
        </>
      );
    }
    // If only logo is available, show only logo
    else if (logoImage) {
      return <img src={logoImage} alt="Company Logo" className="logo-image logo-only" />;
    }
    // If only name is available or nothing is available, show name or default
    else {
      return <span className="business-name">{businessName || 'BusinessInfo'}</span>;
    }
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          {renderBrandContent()}
        </Link>
        
        <div className="menu-icon" onClick={toggleMenu}>
          <FontAwesomeIcon icon={isOpen ? solidIcons.faTimes : solidIcons.faBars} />
        </div>
        
        <ul className={isOpen ? 'nav-menu active' : 'nav-menu'}>
          <li className="nav-item">
            <Link to="/" className="nav-link" onClick={() => setIsOpen(false)}>
              Home
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/about" className="nav-link" onClick={() => setIsOpen(false)}>
              About
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/vision" className="nav-link" onClick={() => setIsOpen(false)}>
              Vision
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/services" className="nav-link" onClick={() => setIsOpen(false)}>
              Services
            </Link>
          </li>
          {getData('products.enabled', false) && (
            <li className="nav-item">
              <Link to="/products" className="nav-link" onClick={() => setIsOpen(false)}>
                Products
              </Link>
            </li>
          )}
          <li className="nav-item">
            <Link to="/contact" className="nav-link" onClick={() => setIsOpen(false)}>
              Contact
            </Link>
          </li>
          {isDonationEnabled && (
            <li className="nav-item">
              <Link to="/donate" className="nav-link donate-link" onClick={() => setIsOpen(false)}>
                <FontAwesomeIcon icon={solidIcons.faHandHoldingHeart} className="donate-icon" />
                Donate
              </Link>
            </li>
          )}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar; 